import React, {
  useState,
  useCallback,
  useEffect,
} from 'react';
import { Row, Col } from 'antd';
import { useDispatch } from 'react-redux';
import ScheduleOfValuesInput from '../ScheduleOfValuesInput';
import { updateProjectScheduleOfValuePDFRows } from '../../state/projects.actions';
import { isNullOrUndefined } from '../../../helpers/helpers';
import {
  LANDSCAPE_MAX_VALUES,
  PORTRAIT_MAX_VALUES,
} from './sov.pdf.helpers';

const ScheduleOfValuesPDFPreviewFormInput = ({
  projectId,
  templateId,
  pdfRow,
  property,
  title,
  type = 'text',
  style,
  textarea = false,
  isLandscapeOn = false,
}) => {
  const dispatch = useDispatch();
  const [ showPopover, setShowPopover ] = useState(false)
  const [ value, setValue ] = useState(pdfRow[property]);

  useEffect(() => {
    if (showPopover) return;
    setValue(pdfRow[property]);
  }, [pdfRow[property], property, showPopover]);

  const onConfirm = useCallback(async () => {

    let normalizedValue = value;
    if (property === 'spacing' && (value === '' || isNullOrUndefined(value))) {
      normalizedValue = null;
    }

    let updatedRow = {
      key: pdfRow.key,
      value: pdfRow.value,
      xPosition: pdfRow.xPosition,
      yPosition: pdfRow.yPosition,
      spacing: pdfRow.spacing,
      [property]: normalizedValue,
    };

    if(await dispatch(updateProjectScheduleOfValuePDFRows({
      projectId,
      templateId,
      rowId: pdfRow.id,
      payload: updatedRow,
    }))) {
      setShowPopover(false);
    }
  },[value, dispatch, projectId, templateId, pdfRow]);

  const onCancel = useCallback(() => {
    setValue(pdfRow[property]);
    setShowPopover(false);
  }, [pdfRow]);

  const onChange = useCallback((newValue) => {
    setShowPopover(true);
    const newVal = type === 'number' ? newValue : newValue.target.value;
    if (pdfRow[property] === newVal) {
      setShowPopover(false);
    }

    setValue(newVal);
  }, [pdfRow]);

  const maxValueMap = isLandscapeOn ? LANDSCAPE_MAX_VALUES : PORTRAIT_MAX_VALUES;
  const maxValue = maxValueMap[property];

  return (
    <Row style={{ height: '100%' }} align='top' gutter={10}>
      <Col style={{ height: textarea ? undefined : 32 }}>
        <ScheduleOfValuesInput
          title={`Update ${title}`}
          showPopover={showPopover}
          onConfirm={onConfirm}
          onCancel={onCancel}
          onChange={onChange}
          value={value}
          type={type}
          placeholder={title}
          style={style}
          max={maxValue}
          textarea={textarea}
        />
      </Col>
    </Row>
  );
}

export default ScheduleOfValuesPDFPreviewFormInput;
